import React, { useContext } from 'react';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import PropTypes from 'prop-types';
import LayoutContext from '../../contexts/Layout';

const Paragraph = ({ dataSet, extraStyle, text, onPress, wrapperStyle }) => {
    const { layout } = useContext(LayoutContext);

    const paragraphComponent = (
        <View
            style={StyleSheet.flatten(Styles.wrapper, wrapperStyle)}
            dataSet={{
                ...dataSet,
                tagName: 'P',
                fontFamily: layout.styleGuide.p1.fontFamily,
                condensedFontFamily: layout.styleGuide.p1.condensedFontFamily,
                fontSize: layout.styleGuide.p1.fontSize,
                color: layout.styleGuide.p1.color
            }}
        >
            <Text dataSet={{ tagName: 'P' }} style={StyleSheet.flatten(Styles.p, layout.styleGuide.p1, extraStyle)}>
                {text}
            </Text>
        </View>
    );

    if (onPress) {
        return <Pressable onPress={onPress}>{paragraphComponent}</Pressable>;
    }

    return paragraphComponent;
};

const Styles = StyleSheet.create({
    p: {
        color: '#7f868b',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS === 'web' ? '16pt' : 16
    },
    wrapper: {
        width: Platform.OS === 'web' ? '80%' : '100%'
    }
});

Paragraph.propTypes = {
    extraStyle: PropTypes.object,
    text: PropTypes.string.isRequired
};

export default Paragraph;
